<script setup lang="ts">
  import { convertLocationToAddress } from '@/model/location.model'
  import type { Organization } from '@/types/organization'
  import type { Location } from '@/model/location.model'
  import FormHeading from '@/components/form/FormHeading.vue'
  import SelectOrganization from '@/components/organization/SelectOrganization.vue'
  import OrganizationInfo from '@/components/idf-modal/OrganizationInfo.vue'
  import SelectLocation from '@/components/SelectLocation.vue'
  import AddressForm from '@/components/AddressForm.vue'
  import type { Nullish } from '@logistiek-zonder-papier/lzp-library'
  import { computed, type Ref } from 'vue'
  import type { JourneyFieldErrors } from '@/types/idf-journey-product'
  import type { JourneyLocationType } from '@/store/location.store'

  const {
    headingLabel,
    locationLabel,
    locationType,
    error,
    organizationErrorKey,
    addressErrorKey,
  } = defineProps<{
    headingLabel: string
    locationLabel: string
    locationType: JourneyLocationType
    error?: JourneyFieldErrors | Nullish
    organizationErrorKey?: keyof JourneyFieldErrors
    addressErrorKey?: keyof JourneyFieldErrors
    isEdit?: boolean
    required?: boolean
  }>()

  const handlerOrganization = defineModel<Organization | Nullish>('handlerOrganization')
  const handlerAddress = defineModel<Location | Nullish>('handlerAddress')

  const validationMessage = computed(() => {
    if (!error) return undefined
    return error
  })

  const getFieldError = (handler: Ref<unknown>, errorKey: keyof JourneyFieldErrors | undefined) => {
    if (!handler.value && errorKey) {
      return validationMessage.value?.[errorKey]
    }
    return undefined
  }

  const organizationError = computed(() => getFieldError(handlerOrganization, organizationErrorKey))
  const addressError = computed(() => getFieldError(handlerAddress, addressErrorKey))
</script>

<template>
  <FormHeading :label="headingLabel" />
  <SelectOrganization
    v-model="handlerOrganization"
    :error="organizationError"
    :required="required"
  />
  <OrganizationInfo v-if="handlerOrganization" :organization="handlerOrganization" />
  <SelectLocation
    v-if="handlerOrganization"
    v-model="handlerAddress"
    :organization="handlerOrganization"
    :location-type="locationType"
    :label="locationLabel"
    :error="addressError"
  />
  <AddressForm v-if="handlerAddress" :address="convertLocationToAddress(handlerAddress)" />
</template>

<style></style>
